import type React from "react";
import { useAuthenticatedAuthContext } from "../auth/Auth.component";
import SubscriptionComponent from "./Subscriptions.component";

const SubscriptionPage: React.FC = () => {
	const { subscriptions, tickets, selectedCompany } =
		useAuthenticatedAuthContext();

	const isHousingAssociation =
		selectedCompany.subTypeId === "HOUSING_COOPERATIVE_AGREEMENT";
	return (
		<div data-test-id="subscription-page">
			<SubscriptionComponent
				subscriptions={subscriptions}
				tickets={tickets}
				isHousingAssociation={isHousingAssociation}
				hasTravelSubscription={selectedCompany.hasTravelSubscription}
			/>
		</div>
	);
};

export default SubscriptionPage;
